const UiFormItemPropsOption = {
  prop: { type: String },
  label: { type: String },
  width: { type: Number },
  direction: { type: String, default: "row" }
};

export { UiFormItemPropsOption };
//# sourceMappingURL=index.mjs.map
